// Resolve the role-specific dashboard path for an authenticated user.
//
// This mirrors the exact logic in `LoginPage.jsx` so that any authenticated
// surface (landing page header, auth-page bouncer, post-Stripe-checkout
// redirect, etc.) routes the same way the login flow does.
//
//   SUPER_ADMIN          → /admin/dashboard
//   CONSULTANT           → /{slug}/dashboard
//   CONTRACTOR_ADMIN     → /{slug}/dashboard
//   BID_MANAGER          → /{slug}/dashboard
//   REVIEWER             → /{slug}/dashboard
//
// Returns `'/'` as a safe fallback when the user object is missing fields
// (shouldn't happen post-login, but we never want a navigate(undefined)).
export function getDashboardPathForUser(user) {
  if (!user) return '/';
  if (user.role === 'SUPER_ADMIN') return '/admin/dashboard';
  const slug = user.organization_slug || user.workspaceId;
  if (!slug) return '/';
  return `/${slug}/dashboard`;
}
